import lv from "./lv.json";
import en from "./en.json";

export default {
    getTranslations(language) {
        let languageObject = {
            lv: lv,
            en: en
        };
        return languageObject[language];
    }
}